import { TypographyOptions } from '@mui/material/styles/createTypography';

export const typography: TypographyOptions = {
    fontFamily: "'Inter', 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif",
    h1: {
        fontFamily: "'Outfit', 'Inter', sans-serif",
        fontSize: '3rem',
        fontWeight: 700,
        lineHeight: 1.2,
        letterSpacing: '-0.02em',
    },
    h2: {
        fontFamily: "'Outfit', 'Inter', sans-serif",
        fontSize: '2.25rem',
        fontWeight: 600,
        lineHeight: 1.25,
        letterSpacing: '-0.01em',
    },
    h3: {
        fontFamily: "'Outfit', 'Inter', sans-serif",
        fontSize: '1.75rem',
        fontWeight: 600,
        lineHeight: 1.3,
    },
    h4: {
        fontFamily: "'Outfit', 'Inter', sans-serif",
        fontSize: '1.5rem',
        fontWeight: 500,
        lineHeight: 1.35,
    },
    h5: {
        fontFamily: "'Outfit', 'Inter', sans-serif",
        fontSize: '1.25rem',
        fontWeight: 500,
        lineHeight: 1.4,
    },
    h6: {
        fontFamily: "'Outfit', 'Inter', sans-serif",
        fontSize: '1.125rem',
        fontWeight: 500,
        lineHeight: 1.4,
    },
    body1: {
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    body2: {
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    button: {
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 1.75,
        textTransform: 'none',
    },
    caption: {
        fontSize: '0.75rem',
        fontWeight: 400,
        lineHeight: 1.4,
    },
    overline: {
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 2,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
    },
};
